// reducers.js

import {
  FECTH_TVSCHEDULETIME_ZONE_REQUEST, // Import action type for requesting TV schedule timezone data
  FECTH_TVSCHEDULETIME_ZONE_SUCCESS, // Import action type for successful TV schedule timezone data fetch
  FECTH_TVSCHEDULETIME_ZONE_FAILURE, // Import action type for TV schedule timezone data fetch failure
} from "../../actions/tvscheduletimezoneAction"; // Import action types

// Initial state for the TV schedule timezone data reducer
const initialState = {
  tvscheduletimezoneData: [], // Initial TV schedule timezone data is an empty array
  isLoading: false, // Initial loading state is false
  isError: null, // Initial error state is null
};

// Reducer function to handle TV schedule timezone data
const TvscheduletimezoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case FECTH_TVSCHEDULETIME_ZONE_REQUEST:
      // When requesting TV schedule timezone data, set isLoading to true and reset isError
      return {
        ...state,
        isLoading: true,
        isError: null,
      };
    case FECTH_TVSCHEDULETIME_ZONE_SUCCESS:
      // When TV schedule timezone data fetch is successful, update tvscheduletimezoneData, set isLoading to false, and reset isError
      return {
        ...state,
        tvscheduletimezoneData: action.payload, // Update TV schedule timezone data with the fetched data
        isLoading: false,
        isError: null,
      };
    case FECTH_TVSCHEDULETIME_ZONE_FAILURE:
      // When TV schedule timezone data fetch fails, set isLoading to false and update isError with the error message
      return {
        ...state,
        isLoading: false,
        isError: action.payload, // Update error state with the error message
      };
    default:
      return state;
  }
};

export default TvscheduletimezoneReducer;
